import useHttpClient from 'hooks/useHttpsClient'

const useTeamService = () => {
    const { sendRequest } = useHttpClient();
    const getTeamTopicScores = async () => {
        try {
            const response = await sendRequest('/analytics/tts', 'get')
            if (response.status == 200) {
                return response.data
            }
        } catch (err) {
            console.log("Problem receiving chart data")
        }
    }
    const getSkillScoresByTeam = async () => {
        try {
            const response = await sendRequest('/analytics/sst', 'get')
            if (response.status == 200) {
                return response.data
            }
        } catch (err) {
            console.log("Problem receiving chart data")
        }
    }   
    const getScenariosPerSkillByTeam = async () => {
        try {
            const response = await sendRequest('/analytics/spst', 'get')
            if (response.status == 200) {
                return response.data
            }
        } catch (err) {
            console.log("Problem receiving chart data")
        }
    }
    const getTeamScenarioPerformance = async () => {
        try {
            const response = await sendRequest('/analytics/tsp', 'get')
            if (response.status == 200) {
                return response.data
            }
        } catch (err) {
            console.log("Problem receiving chart data")
        }
    }
    return {
        getTeamTopicScores,
        getSkillScoresByTeam,
        getScenariosPerSkillByTeam,
        getTeamScenarioPerformance,
    }
}

export default useTeamService